import {useLocation, useNavigate} from 'react-router-dom';
import DotsLoading from '../../../components/dotsLoading';
import SelectTestItems from '../../../module/shop/lab/selectTestItems/selectTestItems';
import UseGetTests from '../../shop/create/lab/hooks/useGetTests';
import {useState} from 'react';
import CustomButton from '../../../components/customButton';
import classNames from 'classnames';
import styles from './selectTests.module.scss';
import {useLab} from '../../../context/labContext';
import UseUpdateLabShop from '../hooks/useUpdateLabShop';
import Header from '../../../components/header';
import useSelectLabTests from './hooks/useSelectLabTests';

const SelectTests = () => {
  const {state} = useLocation();

  const {updateLab} = UseUpdateLabShop();
  const {isLoading, labTests, isSuccess} = UseGetTests(state?.activityIds);
  const [selectableLabTests, setSelectableLabTests] = useState<Array<ILabTest>>(
    [],
  );
  const {updateLabTests, lab} = useLab();
  const navigate = useNavigate();
  useSelectLabTests({isSuccess, labTests, lab, setSelectableLabTests});

  const handleClick = () => {
    updateLabTests({tests: selectableLabTests.filter(x => x.selected)} || []);
    navigate('/lab/edit/info');
  };
  if (!lab) {
    navigate('/lab/home');
    return null;
  }
  const handleUpdate = () => {
    updateLab({
      guid: lab?.guid || '',
      lab_tests: selectableLabTests
        .filter(x => x.selected)
        .map(item => item.guid)
        .toString(),
    });
  };
  return (
    <>
      <Header title={'ایجاد آزمایشگاه'} />
      <div className={classNames('d-flex flex-column', styles['select-tests'])}>
        <div className="text-center pt-5">
          <h6 className="color-gray-1">انتخاب خدمات قابل ارائه</h6>
        </div>
        <div className="flex-grow-1">
          {isLoading ? (
            <DotsLoading />
          ) : (
            <>
              <SelectTestItems
                tests={selectableLabTests}
                setSelectableLabTests={setSelectableLabTests}
              />
            </>
          )}
        </div>
        <div className="py-3 d-flex  gap-2">
          <CustomButton
            onClick={handleClick}
            disabled={selectableLabTests.map(x => x.selected).length === 0}
            className={styles['continue-btn']}
          >
            ادامه
          </CustomButton>
          <CustomButton
            onClick={handleUpdate}
            disabled={selectableLabTests.map(x => x.selected).length === 0}
          >
            ثبت تغییرات
          </CustomButton>
        </div>
      </div>
    </>
  );
};

export default SelectTests;
